export enum ScorecardTopicResult {
	PASSED = 'PASSED',
	FAILED = 'FAILED',
	AUTO_FAIL = 'AUTO_FAIL',
	NOT_APPLICABLE = 'NOT_APPLICABLE'
}